import { render, staticRenderFns } from "./fixTopic.vue?vue&type=template&id=0356e870&scoped=true&"
import script from "./fixTopic.vue?vue&type=script&lang=js&"
export * from "./fixTopic.vue?vue&type=script&lang=js&"
import style0 from "./fixTopic.vue?vue&type=style&index=0&id=0356e870&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356e870",
  null
  
)

export default component.exports